export const AUTH_ERROR = {
  TOKEN_REISSUE_FAILED: 'TOKEN_REISSUE_FAILED',
};
